module.exports = __webpack_public_path__ + "static/media/ic_given_flexibility_yellow.ad7d21cd.svg";